import {
  CheckCircleIcon,
  WarningCircleIcon,
  InfoIcon,
} from '@phosphor-icons/react';
import { cn } from '@/lib/utils';

interface OperatorSystemNoticeProps {
  content: string;
  tone: 'success' | 'failed' | 'skipped';
}

/** A non-agent-voice notice (e.g. a pre-login outcome) — visually set apart from the agent's
 * own turns so it never reads as something the agent said. */
const TONE = {
  success: { Icon: CheckCircleIcon, className: 'text-emerald-600' },
  failed: { Icon: WarningCircleIcon, className: 'text-amber-600' },
  skipped: { Icon: InfoIcon, className: 'text-muted-foreground' },
} as const;

export function OperatorSystemNotice({
  content,
  tone,
}: OperatorSystemNoticeProps) {
  const { Icon, className } = TONE[tone];
  return (
    <div
      className={cn(
        'flex items-center justify-center gap-1.5 py-1 text-center text-xs',
        className,
      )}
    >
      <Icon className="h-3.5 w-3.5 shrink-0" weight="fill" />
      <span>{content}</span>
    </div>
  );
}
